import { useEffect, useState } from 'react';

declare var Chargebee: any;

function useChargebeeScript() {
  const [cbInstance, setCbInstance] = useState<any>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://js.chargebee.com/v2/chargebee.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (Chargebee) {
        const cbInstance = Chargebee.init({
          site: process.env.REACT_APP_CHARGEBEE_SITE,
        });
        setCbInstance(cbInstance);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return cbInstance;
}

export default useChargebeeScript;